import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {b64toBlob, deepCopyObject, showAxiosError} from "../../util/Helpers";
import {Label, UncontrolledTooltip} from "reactstrap";
import './OperatingCertificate.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import FileSaver from 'file-saver';
import {validateComponent, validateField} from "../../common/validation";
import Alert from "react-s-alert";
import Select from "../../local_node_modules/react-select"
import {input} from "antd";
import Maskedinput from "react-text-mask";

class OperatingCertificateForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: true,
            outstandingAccruals: [],
            mode: this.props.mode,
            hasTransfer: false,
            showButton: false,
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: "",
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: "",
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                mezuniyetTarihi: "",
                diplomaNo: "",
                ruhsatTarihi: "",
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: false,
                uyelikAktif: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                transferTo: "",
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                }
            },
            certificateDetails: {
                givenTo: null,
                forEsign: false,
            },
            healthWorkerCertificateDetails: {
                hesCode: null,
                note: null,
            },
            certificateType: null,
            certificateTypes: [
                {label: "Oda Kayıt Belgesi", value: "OperatingCertificate"},
                {label: "Meslek Mensubu Kimlik Sureti", value: "HealthCertificate"},
            ],
        };
        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
        this.listOutstandingAccruals = this.listOutstandingAccruals.bind(this);
        this.onChangeHCCertificate = this.onChangeHCCertificate.bind(this);
    }

    async componentDidMount() {
        if (this.props.selectedMember) {
            let selectedMember = deepCopyObject(this.props.selectedMember);
            this.setState({memberInfo: selectedMember});
        }
        //this.listOutstandingAccruals();
    }


    onChange(e) {
        this.setState({
            certificateDetails: {
                ...this.state.certificateDetails,
                [e.target.name]: e.target.value.toString().toLocaleUpperCase()
            }
        })
    }

    onChangeHCCertificate(name, value) {
        this.setState({
            healthWorkerCertificateDetails: {
                ...this.state.healthWorkerCertificateDetails,
                [name]: value.toString()
            }
        })

    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result;
    }

    async listOutstandingAccruals() {
        let self = this;
        let fieldsDisabled = true;
        let params = {
            url: API_BASE_URL + "/accrual/outstandingAccrualsAfterDueDate/" + this.props.selectedMember.id,
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                console.log("outstandingAccruals", response.data);
                let outstandingAccruals = response.data;
                if (Array.isArray(outstandingAccruals) && outstandingAccruals.length === 0) {
                    fieldsDisabled = false;
                }
                self.setState({
                    outstandingAccruals, fieldsDisabled
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    onChangeCheckBox(name, value) {
        let certificateDetails = this.state.certificateDetails;
        certificateDetails[name] = value;
        this.setState({certificateDetails});
    }

    handleExport() {
        let self = this;
        let validity = this.validateComponent();
        if (validity.valid) {
            self.setState({isLoading: true});
            let certificateDetails = deepCopyObject(self.state.certificateDetails);
            let healthWorkerCertificateDetails = deepCopyObject(self.state.healthWorkerCertificateDetails);
            let url = (this.state.certificateType === "OperatingCertificate") ?
                API_BASE_URL + "/uye/operating-certificate/" + self.state.memberInfo.id
                :
                API_BASE_URL + "/uye/health-worker-certificate-admin/" + self.state.memberInfo.id;

            let fileSuffix = (this.state.certificateType === "OperatingCertificate") ?
                "_OdaKayitBelgesi.pdf"
                :
                "_Meslek_Mensubu_Kimlik_Sureti.pdf";

            let params = {
                url: url,
                data: this.state.certificateType === "OperatingCertificate" ? certificateDetails : healthWorkerCertificateDetails,
                method: "post"
            };
            request(params).then(function (response) {
                const data = response.data.substring(response.data.indexOf(',') + 1);
                var blob = b64toBlob(data, 'application/pdf;charset=utf-8');
                FileSaver.saveAs(blob, self.state.memberInfo.tcKimlikNo + fileSuffix);
                let certificateDetails = {givenTo: null, forEsign: false};
                let healthWorkerCertificateDetails = {hesCode: null, note: null};

                self.setState({
                    isLoading: false,
                    showButton: false,
                    certificateDetails,
                    healthWorkerCertificateDetails,
                });
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({
                    isLoading: false,
                });
            });
        } else {
            Alert.error('İstenilen Bilgileri Eksiksiz Doldurunuz !', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    onSelectChange(name, value) {
        let certificateType;
        if (value === null) {
            certificateType = null;
        } else {
            certificateType = value.value;
        }
        this.setState({certificateType});
    }

    onChangeHesCode(v) {
        let healthWorkerCertificateDetails = deepCopyObject(this.state.healthWorkerCertificateDetails);
        let value = v.toUpperCase();
        let index = value.indexOf('_');
        if (index !== -1) {
            if (value.length && index === 12)
                this.setState({showButton: true});
            else
                this.setState({showButton: false});
        } else
            this.setState({showButton: true});

        healthWorkerCertificateDetails.hesCode = value;
        this.setState({healthWorkerCertificateDetails});
    }


    render() {
        console.log("this.state:", this.state);
        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">Üye Bilgileri</h4>
                </div>
                <div className="memberTransferForm-container">
                    <div className="card-body">
                        <div className="FormRenk col-sm-12">
                            <div className="row">
                                <Label className="col-sm-4">TC Kimlik No:</Label>
                                <Label className="col-sm-8">{this.state.memberInfo.tcKimlikNo}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-4">Ad:</Label>
                                <Label className="col-sm-8">{this.state.memberInfo.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-4">Soyad:</Label>
                                <Label className="col-sm-8">{this.state.memberInfo.soyad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-4">Sicil No:</Label>
                                <Label className="col-sm-8">{this.state.memberInfo.odaSicilNo}</Label>
                            </div>

                            <div className="row">
                                <Label className="col-sm-4">Şehir:</Label>
                                <Label className="col-sm-8">{this.state.memberInfo.city.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-4">Oda:</Label>
                                <Label className="col-sm-8">{this.state.memberInfo.city.oda.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-4">Üyelik Durumu:</Label>
                                <Label
                                    className="col-sm-8">{this.state.memberInfo.uyelikAktif ? "AKTİF" : "PASİF"}</Label>
                            </div>
                            {/* <div className="row">
                                <Label className="col-sm-4">Borç Bilgileri:</Label>
                                <Row className="col-sm-8">
                                    <Col sm="12" style={{
                                        paddingTop: "0px",
                                        paddingRight: "15px",
                                        paddingLeft: "15px",
                                        maxHeight: '500px',
                                        overflow: "auto"
                                    }}>
                                        <table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
                                            <thead>
                                            <tr style={{backgroundColor: '#ebedf0'}}>
                                                <th width="5%">#</th>
                                                <th>Dönem</th>
                                                <th>Tip</th>
                                                <th>Meblağ</th>
                                                <th>Son Ödeme Tarihi</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.outstandingAccruals && this.state.outstandingAccruals.map((document, index) =>
                                                <tr key={index + "_" + document.relatedYear + "_" }>
                                                    <td>{index + 1}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{<TextOverFlowTooltip text={document.relatedYear || "-"} maxLength={30}/>}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{<TextOverFlowTooltip text={document.accrualType==='YearlyFee'?'Yıllık Aidat':'Oda G. Aidatı' || "-"} maxLength={30}/>}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{<TextOverFlowTooltip text={document.amount + ' ₺'|| "-"} maxLength={30}/>}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{<TextOverFlowTooltip text={document.accrualDueDate&&new Date(document.accrualDueDate).toLocaleDateString('tr')  || "-"} maxLength={30}/>}</td>
                                                </tr>
                                            )}
                                            {(this.state.outstandingAccruals && this.state.outstandingAccruals.length === 0) &&
                                            <tr>
                                                <td colSpan="8">Kayıt bulunamadı</td>
                                            </tr>
                                            }
                                            </tbody>
                                        </table>
                                    </Col>
                                    <Col sm="12">
                                        <p/>
                                        <p style={{float: "left"}}>
                                            {
                                                this.state.outstandingAccruals
                                                    ?
                                                    (this.state.outstandingAccruals.length !== 0)
                                                        ? <span style={{color: "red",fontWeight:"bold"}}>{'Toplam ' +  this.state.outstandingAccruals.length +' Adet Son Ödeme Tarihi Geçmiş Borç Kaydı Bulundu. Oda Kayıt Belgesi İndirilemez!'}</span>
                                                        : <span style={{color: "green",fontWeight:"bold"}}>{'Son Ödeme Tarihi Geçmiş Borç Kaydı Bulunamadı. Belge İndirilebilir.'}</span>
                                                    : <span style={{color: "green",fontWeight:"bold"}}>{'Borç Kayıtları Sorgulanıyor!'}</span>

                                            }
                                        </p>
                                    </Col>
                                </Row>
                            </div>*/}
                        </div>

                        {<div className="FormRenk col-sm-12">
                            <div className='col-sm-12 row'>
                                <div className="col-sm-4">
                                    <label>Belge Tipi *:</label>
                                </div>
                                <div className="col-sm-8">
                                    <div className={"form-group" + this.validateClass('tCertificateType')}>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            placeholder="Belge tipi seçiniz."
                                            isClearable={false}
                                            isSearchable={true}
                                            name="certificateType"
                                            id="tCertificateType"
                                            style={{flex: 0.9}}
                                            onBlur={this.validateField}
                                            inputProps={{'vdata': "required"}}
                                            ref="tCertificateType"
                                            options={this.state.certificateTypes}
                                            onChange={(value) => this.onSelectChange("certificateType", value)}
                                            value={this.state.certificateType}
                                        />

                                        {this.validateMessage('tCertificateType') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tCertificateType" delay={0}>
                                            {this.validateMessage("tCertificateType")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            {this.state.certificateType && (this.state.certificateType === "OperatingCertificate") &&
                            <div>
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-4">
                                        <label>Nereye Verileceği *:</label>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className={"form-group" + this.validateClass('tGivenTo')}>
                                            <input className="form-control"
                                                   type="text"
                                                   name="givenTo"
                                                   id="tGivenTo"
                                                   maxLength="25"
                                                   data-vlength="5,25"
                                                   onBlur={this.validateField}
                                                   ref="tGivenTo"
                                                   value={this.state.certificateDetails.givenTo || ""}
                                                   onChange={(e) => this.onChange(e)}
                                            />
                                            {this.validateMessage('tGivenTo') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tGivenTo" delay={0}>
                                                {this.validateMessage("tGivenTo")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-4">
                                        <label>E-İmza/Zaman Damgası İçin:</label>
                                    </div>
                                    <div className="col-sm-8">
                                        <div>
                                            <input type="checkbox"
                                                   name="forESign"
                                                   id="tForESign"
                                                   value={this.state.certificateDetails.tForESign}
                                                   onChange={(e) => this.onChangeCheckBox("forEsign", e.target.checked)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {this.state.certificateType === "HealthCertificate" && <div>
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-4">
                                        <label>HES Kodu *:</label>
                                    </div>
                                    <div className={"col-sm-8 form-group" + this.validateClass('hesCode')}>
                                        <Maskedinput className="form-control"
                                                     mask={[/[A-Za-z]/, /\d/, /[A-Za-z]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                                     type="text"
                                                     name={"hesCode"}
                                                     id={"hesCode"}
                                                     inputProps={{vdata: "hesCode", vlength: '12'}}
                                                     placeholder="____-____-__"
                                                     onBlur={() => this.validateField({
                                                         target: {
                                                             id: "hesCode",
                                                             dataset: {vdata: "hesCode", vlength: '11,12'},
                                                             value: this.state.healthWorkerCertificateDetails.hesCode
                                                         }
                                                     })}
                                                     ref={"hesCode"}
                                                     value={this.state.healthWorkerCertificateDetails.hesCode}
                                                     onChange={(e) => this.onChangeHesCode(e.target.value)}
                                        />
                                        {this.validateMessage('hesCode') !== "" &&
                                        <UncontrolledTooltip placement="right" target={"hesCode"} delay={0}>
                                            {this.validateMessage("hesCode")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>}

                            {this.state.certificateType === "HealthCertificate" && <div>
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-4">
                                        <label>İlave Notlar:</label>
                                    </div>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tNote')}>
                                        <input className="form-control"
                                               type="text"
                                               name="note"
                                               id="tNote"
                                               maxLength="100"
                                               value={this.state.healthWorkerCertificateDetails.note || ""}
                                               onChange={(e) => this.onChangeHCCertificate("note", e.target.value)}/>
                                        {this.validateMessage('tNote') !== "" &&
                                        <UncontrolledTooltip placement="right" target={"tNote"} delay={0}>
                                            {this.validateMessage("tNote")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                                <Label col-sm-12 row style={{color: "red"}}>
                                    Meslek Mensubu Kimlik Sureti almak için HES Kodu zorunludur* </Label>

                            </div>
                            }
                        </div>}

                    </div>
                </div>
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"160px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8"/>
                        {<div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"160px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.isLoading ||
                                    ((this.state.certificateType === "HealthCertificate")
                                        ? (!this.state.showButton || !this.state.healthWorkerCertificateDetails.hesCode)
                                        : (!this.state.memberInfo.uyelikAktif || !this.state.memberInfo.uyeCalisiyor  || !this.state.certificateDetails.givenTo))}
                                    onClick={() => this.handleExport()}>Belge İndir
                            </button>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default OperatingCertificateForm;



// WEBPACK FOOTER //
// ./src/page/operatingCertificate/OperatingCertificateForm.js